
import { Component, Vue, Prop } from 'vue-property-decorator';

import Popup from '@/components/Popup/index.vue';

@Component({
  components: {
    Popup,
  },
})
class NoticePanel extends Vue {
  @Prop({ required: true, default: () => ([]) }) notice;

  open: boolean = false;
}

export default NoticePanel;
